import { useEffect, useState } from 'react';

import { client, useErrorNotifications } from 'core/http';
import { User } from 'core/types/user';

export default function useCustomerUsers(customerId: number) {
  const showErrorNotification = useErrorNotifications();
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState<User[]>([]);

  useEffect(() => {
    if (!customerId) return;
    setLoading(true);

    client()
      .get<{ data: User[] }>(`customers/${customerId}/users`)
      .then(response => response.data.data)
      .then(setUsers)
      .catch(showErrorNotification)
      .finally(() => setLoading(false));
  }, [customerId, showErrorNotification]);

  return { users, loading };
}
